// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S6PWm","largestCol":"styles_largestCol__2Ll5L","smallestCol":"styles_smallestCol__3m20j"};